import BaseApiService from './base-api.service';

export default class DashService {
  jwt = null;
  _client = null;

  constructor(jwt, baseUrl) {
    if (!jwt) throw new Error('JWT is required');
    this.jwt = jwt;

    let headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    };

    this._client = new BaseApiService({
      baseURL: baseUrl,
      headers,
    });
  }

  static async getTokenFromCode(code, clientId, baseUrl) {
    const response = await new BaseApiService({
      baseURL: baseUrl,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).post('/api/oauth2/token', { code, clientId });
    return response.data;
  }
}
